import NewsRepository from '@/repositories/NewsRepository'
import VoiceRepository from '@/repositories/VoiceRepository'
import NewsEntity from '@/entities/News'
import VoiceEntity from '@/entities/Voice'

export interface IPresenterParams {
  newsRepository: NewsRepository
  voiceRepository: VoiceRepository
  featuredNewsId: string | null
}

export interface IPresenter {
  newsList: NewsEntity[]
  voices: VoiceEntity[]
  news: NewsEntity[]
}

export default ({ newsRepository, voiceRepository, featuredNewsId }: IPresenterParams): IPresenter => {
  const featuredNews = featuredNewsId ? newsRepository.getNewsById(featuredNewsId) : null
  const newsList = featuredNews ? [featuredNews] : []
  return {
    newsList: newsRepository.getNewsList({ limit: 10 }),
    voices: voiceRepository.getVoices(),
    news: newsList
  }
}
